export const RAIL_SLOT_VARIABLE = '--hop-rail-slot'

export const RAIL_SLOT_SIZE = `var(${RAIL_SLOT_VARIABLE}, 1.6875rem)`

export const RAIL_ICON_HOVER_SCALE = 1.44

// Above the left menu (z-index 1000) and the cut offers banner (1100), like the banner's own tooltips.
export const RAIL_OVERLAY_Z_INDEX = 1200

export const RAIL_OVERLAY_OFFSET_PX = 8
